/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Default Avatar Icon component.
 */
export const DefaultAvatarIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M11.87 10.7584C14.0861 10.7584 15.8826 9.02162 15.8826 6.8792C15.8826 4.73678 14.0861 3 11.87 3C9.65393 3 7.85742 4.73678 7.85742 6.8792C7.85742 9.02162 9.65393 10.7584 11.87 10.7584Z'
        stroke={iconColor} strokeWidth={1.5} strokeMiterlimit='10' />
      <path d='M3 19.1736C3 15.8599 5.68629 13.1736 9 13.1736H14.0008C17.3145 13.1736 20.0008 15.8599 20.0008 19.1736V20.5C20.0008 20.7762 19.7769 21 19.5008 21H3.5C3.22386 21 3 20.7762 3 20.5V19.1736Z'
        stroke={iconColor} strokeWidth={1.5} />
    </svg>
  );
};
DefaultAvatarIcon.defaultProps = {
  size  : IconSize.medium,
  color : Color.white
};
export default DefaultAvatarIcon;
